import { AnalyticsEvent, EventCategories, EventParam } from "@core/analytics/analytics-event";
import { isNotNil } from "@utils/assert";

export const ANALYTICS_UNDEFINED_PARAM_VALUE = "_";

export type AnalyticsDimension = string | number | null;

export abstract class AnalyticsTracker {
	abstract trackEvent(event: AnalyticsEvent<EventCategories>): Promise<void>;

	abstract setCustomDimension(dimensionName: string, dimensionValue: AnalyticsDimension): Promise<void>;

	abstract trackView(customTitle?: string, customUrl?: string): Promise<void>;

	async setUserId(userId: string | null): Promise<void> {
		await this.setCustomDimension("PTID", userId);
	}

	buildParamsLabel(params?: EventParam[]): string {
		if (isNotNil(params)) {
			return params.map(param => (isNotNil(param) ? param : ANALYTICS_UNDEFINED_PARAM_VALUE)).join(" | ");
		}
		return "";
	}
}
